import { render, staticRenderFns } from "./Valuation.vue?vue&type=template&id=27175645&scoped=true&"
import script from "./Valuation.vue?vue&type=script&lang=js&"
export * from "./Valuation.vue?vue&type=script&lang=js&"
import style0 from "./Valuation.vue?vue&type=style&index=0&id=27175645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27175645",
  null
  
)

export default component.exports